const actionTypeIdentifier = "BC7C77AF-6198-4DC5-9D71-B4BE2B641A4F";

export const setManageUserHistoryLogsLoading = `SET-MANAGE-USER-HISTORY-LOGS-LOADING-${actionTypeIdentifier}`;
export const getManageUserHistoryLogs = `GET-MANAGE-USER-HISTORY-LOGS-${actionTypeIdentifier}`;
export const setManageUserHistoryPageSize = `SET-MANAGE-USER-HISTORY-PAGE-SIZE-${actionTypeIdentifier}`;
export const resetManageUserHistory = `RESET-MANAGE-USER-HISTORY-${actionTypeIdentifier}`;
export const setManageUserHistoryColSearchStr = `SET-MANAGE-USER-HISTORY-COL-SEARCH-${actionTypeIdentifier}`;
